<template>
    <div id="ecology">
        <div class="ecology1">
            <img :src="url+banner.images" alt="" class="bg"  @click="jumpbannerpage(banner.url)">
        </div>
        <div class="ecology2">
            <ul>
                <li  class="wow animate__animated animate__fadeInLeft"><img :src="url+ecology2.images" alt=""></li>
                <li  class="wow animate__animated animate__fadeInRight">
                    <div v-html="ecology2.title"></div>
                    <div v-html="ecology2.subtitle"></div>
                </li>
            </ul>
        </div>
        <div class="ecology3">
            <div class="ecology3Box">
                <p class="title">开放API接口</p>
                <ul>
                    <li v-for="(item,index) in ecology3" :key="index"  class="wow animate__animated animate__fadeInDown">
                        <img :src="url+item.images" alt="">
                        <p>{{item.title}}</p>
                    </li>
                </ul>
                <p class="subtitle">更多接口服务请联系客服</p>
                <button  @click="submit(false)">联系客服</button>
            </div>
        </div>
        <div class="ecology4">
            <p class="title">加入我们</p>
            <p class="subtitle">谁可以加入我们？</p>
            <ul class="ul1">
                <li v-for="(item,index) in ecology4" :key="index"  class="wow animate__animated animate__fadeInDown">
                    <img :src="url+item.images" alt="">
                    <p>{{item.title}}</p>
                </li>
            </ul>
            <p class="subtitle">合伙人扶持</p>
            <ul class="ul2">
                <li v-for="(item,index) in ecology5" :key="index"  class="wow animate__animated animate__fadeInDown">
                    <img :src="url+item.images" alt="">
                    <p v-show="item.title">{{item.title}}</p>
                </li>
            </ul>
            <p class="subtitle">合伙人可获得权益</p>
            <ul class="ul2">
                <li v-for="(item,index) in ecology6" :key="index"  class="wow animate__animated animate__fadeInDown">
                    <img :src="url+item.images" alt="">
                    <p v-show="item.title">{{item.title}}</p>
                </li>
            </ul>
        </div>
        <mydialog v-if="showtc2" @tcstatus="tcstatus" :dialogVisible1="tcshow" :imgurl="url+weichat.images"></mydialog>
    </div>
</template>

<script>
import mydialog from '@/components/dialog/dialog.vue'
import { rotationmap,ecology } from '@/api/api'
export default {
    name:"ecology",
    components: {
        mydialog
    },
    data(){
        return {
            showtc2:false,
            tcshow:true,
            url : window.url,
            banner: {}, 
            ecology2:{},
            ecology3:[],
            ecology4:[],
            ecology5:[],
            ecology6:[],
            weichat:{}
        }
    },
    mounted(){
        var that = this
        rotationmap({'type':4}).then((response) => {
            that.banner = response.data.data[0]
        })
        rotationmap({'type':14}).then((response) => {
            that.weichat = response.data.data[0]
        })
        ecology().then((response) => {
            that.ecology2 = response.data.data[0][0]
            that.ecology3 = response.data.data[1]
            that.ecology4 = response.data.data[2]
            that.ecology5 = response.data.data[3]
            that.ecology6 = response.data.data[4]
            //初始化动画
            that.$nextTick(()=>{
                that.$wow.init()
            })
        })
    },
    methods:{
        tcstatus(e){
            this.showtc2 = e
        },
        submit(e){
            this.showtc2 = true
            this.tcshow = e
        },
        jumpbannerpage(e){
            if(e != this.$route.path) {
                this.$router.push(e)
            }
        }
    }
}
</script>

<style lang="less">
:root {
    --web-title-fontsize: 30px;
    --web-subtitle-fontsize: 22px;
    --web-text-fontsize: 16px;
} 
@media (min-width:750px) {
    #ecology{
        .ecology1{
            .bg{
                width: 100%;
            }
        }
        .ecology2{
            width: 1300px;
            margin:50px auto 60px;
            ul{
                display: flex;
                img{
                    width: 20px;
                    margin-right: 30px;
                }
                font-size: var(--web-subtitle-fontsize);
                font-weight: 400;
                color: #444444;
            }
        }
        .ecology3{
            background: #F5F8FF;
            .ecology3Box{
                width: 1300px;
                margin:0 auto;
                padding: 30px 0;
                .title{
                    font-size: var(--web-title-fontsize);
                    color: #353535;
                    text-align: center;
                    margin-bottom: 36px;
                }
                .subtitle{
                    text-align: center;
                    font-size: var(--web-subtitle-fontsize);
                    color: #979797;
                    margin-top: 50px;
                }
                button{
                    width: 285px;
                    height: 70px;
                    background: #5B7CFA;
                    border-radius: 35px 35px 35px 35px;
                    display: block;
                    margin:42px auto 0;
                    font-size: 20px;
                    color: #FFFFFF;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    img{
                        width: 80px;
                        margin-bottom: 10px;
                    }
                    li{
                        width: 220px;
                        height: 220px;
                        background: #FFFFFF;
                        border-radius: 10px 10px 10px 10px;
                        text-align: center;
                        padding: 40px;
                        font-size: var(--web-subtitle-fontsize);
                        font-weight: bold;
                        color: #353535;
                    }
                }
            }
        }
        .ecology4{
            width: 1300px;
            margin: 60px auto 0;
            .title{
                font-size: var(--web-title-fontsize);
                color: #353535;
                text-align: center;
                margin-bottom: 36px;
            }
            .subtitle{
                display: inline-block;
                font-size: var(--web-subtitle-fontsize);
                font-weight: 800;
                color: #353535;
                position: relative;
                margin-bottom: 46px;
            }
            .subtitle::after{
                content:"";
                display: block;
                width: 105%;
                height: 16px;
                background: #C9D4FF;
                position: absolute;
                bottom: 0;
                left: 0;
                z-index: -1;
            }
            .ul1{
                display: flex;
                justify-content: space-between;
                img{
                    width: 80px;
                    margin-bottom: 10px;
                }
                li{
                    width: 220px;
                    height: 220px;
                    background: #FFFFFF;
                    border-radius: 10px 10px 10px 10px;
                    text-align: center;
                    padding: 40px;
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: bold;
                    color: #353535;
                }
            }
            .ul2{
                padding: 0 40px;
                text-align: center;
                margin-bottom: 20px;
                li{
                    margin-bottom: 20px;
                }
                p{
                    font-size: var(--web-subtitle-fontsize);
                    font-weight: bold;
                    color: #353535;
                    margin:15px auto 0;
                }
                img{
                    width: 100%;
                }
            }
        }
    }
}
@media screen and (max-width:750px) {
    #ecology{
        .ecology1{
            .bg{
                width: 100%;
            }
        }
        .ecology2{
            width: 100%;
            margin:3.125rem auto 3.75rem;
            ul{
                display: flex;
                img{
                    width: 1.875rem;
                    margin-right: 1.875rem;
                }
                font-size: 1rem;
                font-weight: 400;
                color: #444444;
            }
        }
        .ecology3{
            background: #F5F8FF;
            .ecology3Box{
                width: 100%;
                margin:0 auto;
                padding: 1.875rem 0;
                .title{
                    font-size: 1.75rem;
                    color: #353535;
                    text-align: center;
                    margin-bottom: 0.625rem;
                }
                .subtitle{
                    text-align: center;
                    font-size: 1rem;
                    color: #979797;
                    margin-top: 1.25rem;
                }
                button{
                    width: 6.25rem;
                    height: 2.5rem;
                    background: #5B7CFA;
                    border-radius: 2.1875rem 2.1875rem 2.1875rem 2.1875rem;
                    display: block;
                    margin:1.25rem auto 0;
                    font-size: 1rem;
                    color: #FFFFFF;
                }
                ul{
                    display: flex;
                    justify-content: space-between;
                    margin:0 0.625rem;
                    img{
                        width: 1.875rem;
                        margin-bottom: 0.625rem;
                    }
                    li{
                        flex:0 0 18%;
                        padding: 0.625rem 0;
                        background: #FFFFFF;
                        border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
                        text-align: center;
                        font-size: 0.75rem;
                        font-weight: bold;
                        color: #353535;
                    }
                }
            }
        }
        .ecology4{
            width: 100%;
            margin: 1.25rem auto 0;
            .title{
                font-size: 1.25rem;
                color: #353535;
                text-align: center;
                margin-bottom: 1.25rem;
            }
            .subtitle{
                display: inline-block;
                font-size: 1.25rem;
                font-weight: 800;
                color: #353535;
                position: relative;
                margin:0 0.625rem 1.25rem;
            }
            .subtitle::after{
                content:"";
                display: block;
                width: 105%;
                height: 1rem;
                background: #C9D4FF;
                position: absolute;
                bottom: 0;
                left: 0;
                z-index: -1;
            }
            .ul1{
                ul{
                    display: flex;
                    justify-content: space-between;
                    margin:0 0.625rem;
                    img{
                        width: 1.875rem;
                        margin-bottom: 0.625rem;
                    }
                    li{
                        flex:0 0 18%;
                        padding: 0.625rem 0;
                        background: #FFFFFF;
                        border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
                        text-align: center;
                        font-size: 0.75rem;
                        font-weight: bold;
                        color: #353535;
                    }
                }
            }
            .ul2{
                display: flex;
                padding: 0 2.5rem;
                text-align: center;
                flex-wrap: wrap;
                li{
                    flex:0 0 100%;
                    background: #FFFFFF;
                    border-radius: 0.625rem 0.625rem 0.625rem 0.625rem;
                    text-align: center;
                    font-size: 0.75rem;
                    font-weight: bold;
                    color: #353535;
                }
                p{
                    font-size: 0.75rem;
                    font-weight: bold;
                    color: #353535;
                    margin:0.9375rem auto 0;
                }
                img{
                    width: 100%;
                }
            }
        }
    }
 
}
</style>